import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getLanguage } from "../../store/rootReducer";
import HrbTranslate from '../language/HrbTranslate';
import links from '../../resources/data/links.json';
import './UpdateEmailFooter.scss';

class UpdateEmailFooter extends Component {

  render() {
    const lang = this.props.language ? this.props.language.toLowerCase() : 'en';
    const helpCentreUrl = links.links.help_centre[lang];

    return (
      <footer className="hrb-update-email-footer">
        <div className="hrb-update-email-footer-content">
          <a 
            href={helpCentreUrl}
            className="hrb-update-email-footer-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <HrbTranslate text="update_email.footer.help_centre" />
          </a>
          <span className="hrb-update-email-footer-separator"> - </span>
          <a 
            href="tel:1-844-722-5625"
            className="hrb-update-email-footer-link"
          >
            <HrbTranslate text="update_email.footer.phone" />
          </a>
        </div>
      </footer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: getLanguage(state)
  };
};

export default connect(mapStateToProps)(UpdateEmailFooter);
